"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GeneratorHelpers_1 = require("../utils/GeneratorHelpers");

var prefix = 'did:op:';

var DID = function () {
  function DID(id) {
    this.id = id;
  }

  DID.parse = function (didString) {
    if (didString instanceof DID) {
      didString = didString.getDid();
    }

    var did;
    var didMatch = didString.match(/^did:op:([a-f0-9]{64})$/i);

    if (didMatch) {
      did = new DID(didMatch[1]);
    }

    if (!did) {
      throw new Error("Parsing DID failed, " + didString);
    }

    return did;
  };

  DID.generate = function () {
    return new DID(GeneratorHelpers_1.generateId());
  };

  DID.prototype.getDid = function () {
    return "" + prefix + this.id;
  };

  DID.prototype.getId = function () {
    return this.id;
  };

  return DID;
}();

exports.default = DID;